import {
  GET_COST_CENTER,
  CREATE_COST_CENTER,
  DELETE_COST_CENTER,
  UPDATE_COST_CENTER,
  API_RESPONSE_SUCCESS,
  API_RESPONSE_ERROR,
} from "./actionType";

const INIT_STATE = {
  costCenters: [],
  error: {},
  success: "",
};

const CostCenter = (state = INIT_STATE, action) => {
  switch (action.type) {
    case API_RESPONSE_SUCCESS:
      switch (action.payload.actionType) {
        case GET_COST_CENTER:
          return {
            ...state,
            costCenters: action.payload.data,
            success: "",
            error: {},
          };
        case CREATE_COST_CENTER:
          return {
            ...state,
            success: "Sucessfully created cost centers",
            error: {},
          };
        case UPDATE_COST_CENTER:
          return {
            ...state,
            success: "Sucessfully updated cost",
            error: {},
          };
        case DELETE_COST_CENTER:
          return {
            ...state,
            success: "Sucessfully delete cost",
            error: {},
          };
        default:
          return { ...state };
      }
    case API_RESPONSE_ERROR:
      switch (action.payload.actionType) {
        case GET_COST_CENTER:
          return {
            ...state,
            success: "",
            error: action.payload.error,
          };
        case CREATE_COST_CENTER:
          return {
            ...state,
            success: "",
            error: action.payload.error,
          };
        case UPDATE_COST_CENTER:
          return {
            ...state,
            success: "",
            error: action.payload.error,
          };
        case DELETE_COST_CENTER:
          return {
            ...state,
            success: "",
            error: action.payload.error,
          };
        default:
          return { ...state };
      }
    case GET_COST_CENTER: {
      return {
        ...state,
      };
    }
    case CREATE_COST_CENTER: {
      return {
        ...state,
      };
    }
    case UPDATE_COST_CENTER: {
      return {
        ...state,
      };
    }
    case DELETE_COST_CENTER: {
      return {
        ...state,
      };
    }
    default:
      return { ...state };
  }
};

export default CostCenter;
